import React from 'react';
import styles from './steps-login.module.css';
import PropTypes from 'prop-types';

const StepsLogin = ({ view }) => {
    let background1,
        background2,
        background3,
        selectedtext1,
        selectedtext2,
        selectedtext3;

    switch (view) {
        case 1:
            background1 = styles.selected;
            selectedtext1 = styles.selected_text;
            break;
        case 2:
            background2 = styles.selected;
            selectedtext2 = styles.selected_text;
            break;
        case 3:
            background3 = styles.selected;
            selectedtext3 = styles.selected_text;
            break;

        default:
            break;
    }

    return (
        <div className={styles.login__header}>
            <div className={styles.login__header_content}>
                <div className={styles.items}>
                    <div className={styles.item}>
                        <div className={`${styles.circle} ${background1}`}>
                            <span>1</span>
                        </div>
                        <p className={selectedtext1}>Email</p>
                    </div>
                    <hr className={styles.separator} />
                    <div className={styles.item}>
                        <div className={`${styles.circle} ${background2}`}>
                            <span>2</span>
                        </div>
                        <p className={selectedtext2}>Passcode</p>
                    </div>
                    <hr className={styles.separator} />
                    <div className={styles.item}>
                        <div className={`${styles.circle} ${background3}`}>
                            <span>3</span>
                        </div>
                        <p className={selectedtext3}>Complete!</p>
                    </div>
                </div>
                <div className={styles.title}>
                    <p>Register</p>
                </div>
            </div>
        </div>
    );
};
StepsLogin.propTypes = {
    view: PropTypes.number
};
export default StepsLogin;
